import { render, staticRenderFns } from "./CQuill.vue?vue&type=template&id=522f77af&"
import script from "./CQuill.vue?vue&type=script&lang=js&"
export * from "./CQuill.vue?vue&type=script&lang=js&"
import style0 from "./CQuill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports